<template>
    <v-container>
        <v-layout>
            <v-flex>

                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    max-width="500px"
                    transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Agregar / Editar Item</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text v-if="itemTree!=''">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm7 offset-sm1>
                                    <v-text-field
                                            name="codigo"
                                            label="Código"
                                            id="code"
                                            :rules="[v => !!v || 'El código es requerido', v => (v && v.length <= 10)]"
                                            v-model="itemTree.code"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="nombre"
                                            label="Nombre"
                                            id="nombre"
                                            :rules="[v => !!v || 'Es requerido' ]"
                                            v-model="itemTree.name"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            id="trimesterId"
                                            multiple
                                            :items="itemsTrimestre"
                                            v-model="itemTree.trimester"
                                            label="Trimestre"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            id="mondsId"
                                            multiple
                                            :items="items"
                                            v-model="itemTree.months"
                                            label="Meses"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            id="frequencyId"
                                            :items="itemsFrecuencia"
                                            v-model="itemTree.frequency"
                                            label="Frecuencia"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-combobox
                                            id="questionsId"
                                            v-model="itemTree.questions"
                                            :items="questions"
                                            label="Preguntas actividad"
                                            multiple
                                            outlined
                                            dense
                                    ></v-combobox>
                                </v-flex>
                            </v-layout>
                          <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                              <v-switch v-model="itemTree.active "
                                        :label="`${itemTree.active ? 'Aplica' : 'No Aplica'}`"></v-switch>
                            </v-flex>
                          </v-layout>

                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn :disabled="!valid"
                                               @click="saveData"
                                               large color="primary">Guardar
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <br>
      <v-treeview v-if="itemsTree!=[]"
                  :active.sync="active"
                  :items="itemsTree"
                  :load-children="getChildren"
                  :open.sync="open"
                  v-model="tree"
                  activatable
                  active-class="primary--text"
                  class="grey lighten-5"
                  open-on-click
                  :filter="filter"   >
            <template v-slot:label="{ item, active }">
                    <table style="width:100%">
                        <tr>
                            <th width="10%">
                                <v-text-field :readonly="!item.allowEdit"
                                              label="Código"
                                              v-model="item.code"
                                ></v-text-field>
                            </th>
                            <th width="70%">
                                <v-text-field :readonly="!item.allowEdit"
                                              label="Nombre"
                                              v-model="item.name"
                                ></v-text-field>
                            </th>
                            <th>
                                <v-tooltip top>
                                    <v-btn fab dark small @click="addItem(item)" slot="activator" color="primary">
                                        <v-icon dark>add</v-icon>
                                    </v-btn>
                                    <span>Añadir</span>
                                </v-tooltip>
                                <v-tooltip top  v-if="item.allowEdit">
                                    <v-btn fab dark small @click="editItem(item)" slot="activator" color="primary">
                                        <v-icon dark>edit</v-icon>
                                    </v-btn>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.allowEdit">
                                    <v-btn fab dark small @click="deleteItem(item)" slot="activator" color="primary">
                                        <v-icon dark>delete</v-icon>
                                    </v-btn>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </th>
                        </tr>
                    </table>
            </template>
        </v-treeview>
    </v-container>
</template>
<script>
    import Catalog from '../../model/Catalog';

    export default {

        data() {
            return {
                search: '',
                active: [],
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                headers: [
                    {text: 'Tipo', value: 'type'},
                    {text: 'Nombre', value: 'name'},
                    {text: 'ID', value: 'id'},
                    {text: 'Código', value: 'code'},
                    {text: 'Catálogo Padre', value: 'catalogueItemId'},
                    {text: 'Estado', value: 'estado'},
                    {text: 'Acciones', value: 'editar'},
                ],
                itemsTrimestre: ['Q1','Q2','Q3','Q4'],
                items: [1,2,3,4,5,6,7,8,9,10,11,12],
              itemsFrecuencia: ['4 POR MES','2 POR MES','1 POR MES','1 CADA 2 MESES', '1 POR TRIMESTRE', '1 POR SEMESTRE','1 POR AÑO' ,'A DEMANDA'],
                editedIndex: -1,
                catalog: new Catalog(),
                catalogParent: new Catalog(),
                open: [],
                nextId: 0,
                itemsTree:[],
                questions: ["ACTIVIDAD","CONTRATISTA","DÍAS PERDIDOS", "HORAS CAPACITACIÓN","NUMERO DE ASISTENTES","PACIENTE","PUESTO DE TRABAJO","TEMA","TIPO DE PROGRAMA","TIPO DE VACUNA","TIPO DE PROCESOS PELIGROSOS"],
                selectQuestions: [],
                tree: [],
                itemTree:""
            };
        },

        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.catalog = new Catalog();
                this.catalogParent = new Catalog();
                this.valid = false;
                this.dialog = false;
            },
            newCatalog() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
            },
            saveData() {
                if (this.$refs.form.validate()) {
                  if(this.itemTree.months=="" || this.itemTree.months==[] || this.itemTree.months==null){
                    this.itemTree.months = ""
                  }else{
                    this.itemTree.months = JSON.stringify(this.itemTree.months)
                  }
                  if(this.itemTree.questions=="" || this.itemTree.questions==[]|| this.itemTree.questions==null){
                    this.itemTree.questions = ""
                  }else{
                    this.itemTree.questions = JSON.stringify(this.itemTree.questions)
                  }
                  if(this.itemTree.frequency=="" || this.itemTree.frequency==[]|| this.itemTree.frequency==null){
                    this.itemTree.frequency = ""
                  }
                  if(this.itemTree.trimester=="" || this.itemTree.trimester==[]|| this.itemTree.trimester==null){
                    this.itemTree.trimester = ""
                  }else{
                    this.itemTree.trimester = JSON.stringify(this.itemTree.trimester)
                  }

                  if (this.itemTree.id == "") {
                        this.$store.dispatch('addActivityConfigurationCompany', this.itemTree).then(
                            response => {
                              this.itemTree.id = response.data.id
                              this.itemTree.months = JSON.parse(this.itemTree.months)
                              this.itemTree.questions = JSON.parse(this.itemTree.questions)
                              this.itemTree.trimester = JSON.parse(this.itemTree.trimester)
                              this.getParents()
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    } else {
                        this.$store.dispatch('updateActivityConfigurationCompany', this.itemTree).then(
                            response => {
                              this.itemTree.id = response.data.id
                              this.itemTree.months = JSON.parse(this.itemTree.months)
                              this.itemTree.questions = JSON.parse(this.itemTree.questions)
                              this.itemTree.trimester = JSON.parse(this.itemTree.trimester)
                              this.getParents()
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    }
                    this.dialog = false;
                }
            },
            editItem(item) {
              console.log(item)
              console.log(this.itemsTree)
              this.itemTree = item

              this.dialog = true
            },
            addItem(item) {
              this.itemTree = {
                id:"",
                name:"",
                allowEdit:true,
                months:"",
                frequency:"",
                trimester:"",
                activityConfigurationCompany: {id:item.id},
                children:[],
                company:{id:this.$store.state.companyActivity.id}
              }
              this.dialog = true

            },

          async deleteItem(item) {
             if (confirm('Está seguro de que quiere eliminar el registro?')) {
               await  this.$store.dispatch('deleteActivityConfigurationCompany', item.id).then(
                      response => {
                        this.getParents()
                      },
                      error => {
                        this.$store.state.progress = false;
                        this.$store.state.dialogError = true;
                      }
                  );
                }
            },

           async getChildren(item){
              let newObject = {id:item.id, name:item.name,code:item.code,company: {id:this.$store.state.companyActivity.id}}
             await this.$store.dispatch('getActivityConfigurationsCompanyByFather',newObject).then(
                  response => {
                    for (const data of response.data) {
                      if(data.months!=null && data.months!= ''){
                        data.months = JSON.parse(data.months)
                      }
                      if(data.questions!=null && data.questions!= ''){
                        data.questions = JSON.parse(data.questions)
                      }
                      if(data.trimester!=null && data.trimester!= ''){
                        data.trimester = JSON.parse(data.trimester)
                      }
                      data.children = []
                      item.children.push(data)
                    }
                  },
                  error => {
                    this.$store.state.dialogError = true;
                  }
              );
            },
          getParents() {
            this.active = []
            this.open = []
            this.tree= []
            this.itemsTree = []
            this.$store.dispatch('getActivityConfigurationCompanies', this.$store.state.companyActivity.id).then(
                response => {
                  for (const item of response.data) {
                    item.children = []
                    this.itemsTree.push(item)
                  }
                },
                error => {
                  this.$store.state.dialogError = true;
                }
            );
          }
        },
        computed: {
          filter() {
            return this.search
                ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                : undefined
          },
        },
      beforeCreate() {
        this.$store.dispatch('createFirstDataActivityConfigurationsCompany', this.$store.state.companyActivity.id)
      },
      created() {
       this.getParents()

      },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/activity/ActivityConfigurationCompany.vue